export interface AvatarOption {
  id: string;
  label: string;
  emoji: string;
}

export const BUNDLED_AVATARS: AvatarOption[] = [
  { id: 'cat', label: 'Cat', emoji: '🐱' },
  { id: 'dog', label: 'Dog', emoji: '🐶' },
  { id: 'fox', label: 'Fox', emoji: '🦊' },
  { id: 'bear', label: 'Bear', emoji: '🐻' },
  { id: 'owl', label: 'Owl', emoji: '🦉' },
  { id: 'panda', label: 'Panda', emoji: '🐼' },
  { id: 'unicorn', label: 'Unicorn', emoji: '🦄' },
  { id: 'dragon', label: 'Dragon', emoji: '🐲' },
  { id: 'tiger', label: 'Tiger', emoji: '🐯' },
  { id: 'lion', label: 'Lion', emoji: '🦁' },
  { id: 'cow', label: 'Cow', emoji: '🐮' },
  { id: 'pig', label: 'Pig', emoji: '🐷' },
  { id: 'frog', label: 'Frog', emoji: '🐸' },
  { id: 'koala', label: 'Koala', emoji: '🐨' },
  { id: 'penguin', label: 'Penguin', emoji: '🐧' },
  { id: 'eagle', label: 'Eagle', emoji: '🦅' },
  { id: 'wolf', label: 'Wolf', emoji: '🐺' },
  { id: 'butterfly', label: 'Butterfly', emoji: '🦋' },
  { id: 'bee', label: 'Bee', emoji: '🐝' },
  { id: 'turtle', label: 'Turtle', emoji: '🐢' },
  { id: 'shark', label: 'Shark', emoji: '🦈' },
  { id: 'parrot', label: 'Parrot', emoji: '🦜' },
  { id: 'dolphin', label: 'Dolphin', emoji: '🐬' },
  { id: 'croc', label: 'Crocodile', emoji: '🐊' },
  { id: 'ghost', label: 'Ghost', emoji: '👻' },
  { id: 'skull', label: 'Skull', emoji: '💀' },
  { id: 'robot', label: 'Robot', emoji: '🤖' },
  { id: 'pumpkin', label: 'Pumpkin', emoji: '🎃' },
  { id: 'wizard', label: 'Wizard', emoji: '🧙' },
  { id: 'vampire', label: 'Vampire', emoji: '🧛' },
  { id: 'hero', label: 'Hero', emoji: '🦸' },
  { id: 'ninja', label: 'Ninja', emoji: '🥷' },
  { id: 'alien', label: 'Alien', emoji: '👽' },
  { id: 'moon', label: 'Moon', emoji: '🌚' },
  { id: 'star', label: 'Star', emoji: '⭐' },
  { id: 'fire', label: 'Fire', emoji: '🔥' },
  { id: 'diamond', label: 'Diamond', emoji: '💎' },
  { id: 'trophy', label: 'Trophy', emoji: '🏆' },
];
